import { render, staticRenderFns } from "./NewsCate.vue?vue&type=template&id=1dedaee8&scoped=true&"
import script from "./NewsCate.vue?vue&type=script&lang=js&"
export * from "./NewsCate.vue?vue&type=script&lang=js&"
import style0 from "./NewsCate.vue?vue&type=style&index=0&id=1dedaee8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dedaee8",
  null
  
)

export default component.exports